import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from '@SiteComponents/Button'
import Close from '@Images/bulk_action_bar_close.svg'
import Delete from '@Images/bulk_action_bar_delete.svg'

import {
  unselectWorkspaces,
} from '@SiteModules/Workspace/actions'

import {
  openDeleteWorkspacePopup,
} from '@SiteModules/Popup/actions'

import {
  getSelectedWorkspaceIds,
} from '@SiteModules/Workspace/selectors'

import './WorkspacesBulkActionBar.scss'

const BAR_WIDTH = 911 // px, as in WorkspacesBulkActionBar width
const SETTINGS_MAIN_MARGIN_WIDTH = 32 // px, as in SettingsMain.scss

const WorkspacesBulkActionBar: React.FC = () => {
  const dispatch = useDispatch()

  const selectedWorkspaceIds = useSelector(getSelectedWorkspaceIds)
  const numberOfSelectedWorkspaces = selectedWorkspaceIds.length

  const tableElement = document.getElementsByClassName('WorkspacesTable')[0] as HTMLDivElement | undefined
  const sidebarElement = document.getElementsByClassName('Sidebar')[0] as HTMLDivElement | undefined
  const settingsMenuElement = document.getElementsByClassName('SettingsMenu')[0] as HTMLDivElement | undefined

  const tableWidth = tableElement?.offsetWidth || 0
  const sidebarWidth = sidebarElement?.offsetWidth || 0
  const settingsMenuWidth = settingsMenuElement?.offsetWidth || 0

  const style = {
    left: `${sidebarWidth + settingsMenuWidth + SETTINGS_MAIN_MARGIN_WIDTH + 0.5 * (tableWidth - BAR_WIDTH)}px`,
  }

  useEffect(() => {
    if (!tableElement || !sidebarElement) {
      handleClose()
    }
  }, [])

  const handleClose = () => {
    dispatch(unselectWorkspaces())
  }

  const handleOpenDeleteWorkspacePopup = () => {
    dispatch(openDeleteWorkspacePopup({ workspaceIds: selectedWorkspaceIds }))
  }

  const renderDelete = () => {
    return (
      <Button
        caption={numberOfSelectedWorkspaces === 1 ? 'Remove 1 workspace' : `Remove ${numberOfSelectedWorkspaces} workspaces`}
        icon={<Delete />}
        styleType="danger"
        size="small"
        onClick={handleOpenDeleteWorkspacePopup}
      />
    )
  }

  return (
    <div
      className="WorkspacesBulkActionBar"
      style={style}
    >
      <div className="WorkspacesBulkActionBar__left">
        <Close
          onClick={handleClose}
        />
        <div className="WorkspacesBulkActionBar__selected">
          {numberOfSelectedWorkspaces === 1 ? '1 workspace selected' : `${numberOfSelectedWorkspaces} workspaces selected`}
        </div>
      </div>
      <div className="WorkspacesBulkActionBar__right">
        {renderDelete()}
      </div>
    </div>
  )
}

export default WorkspacesBulkActionBar
